<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        SMART MAINTENANCE® Plan
      </div>
      <button
        type="button"
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div class="flex-column margin-bottom-4 margin-top-8">
        <b>Current Plan:</b>
        <span>
          {{ currentPlan }}
          <span v-if="providerPlan?.planId && providerPlan.status !== 'Active'">
            <b>{{ `(${providerPlan.status})` }}</b>
          </span>
        </span>
      </div>
      <div
        v-if="loadingPlans"
        class="loading-container margin-bottom-4"
      >
        <img
          alt="Loading"
          src="@shared/assets/img/general/loading.svg"
        >
      </div>
      <div
        v-else-if="planOptions.length > 0"
        class="flex-column margin-bottom-4"
      >
        <b>Change Member Plan:</b>
        <div class="flex-column margin-bottom-4">
          Select plan for member
        </div>
        <SACDropdown
          placeholder="Select Plan"
          :options="planOptions"
          :value="selectedProviderPlan"
          :change="(field, value) => selectProviderPlan(value)"
          :error="errObj.pleaseSelect"
        />
      </div>
      <div
        v-else
        class="flex-column margin-bottom-4"
      >
        There are no SMART MAINTENANCE® plans to add
      </div>
    </div>
    <div
      v-if="!loadingPlans"
      class="ac-footer-container"
    >
      <button
        v-if="planOptions.length > 0"
        type="button"
        class="ac-form-button"
        @click="updateCustomerProviderPlan"
      >
        Save
      </button>
      <button
        v-else
        type="button"
        class="ac-form-button"
        @click="toggleActionModal(false)"
      >
        Close
      </button>
    </div>
    <ProcessOverlay :show="updating" />
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import SACDropdown from '../../sac/SACDropdown.vue';

export default {
  name: 'ChangeProviderPlan',
  components: {
    SACDropdown,
    ProcessOverlay,
  },
  mixins: [customerDetailMixin],
  data() {
    return {
      selectedProviderPlan: 0,
      updating: false,
      loadingPlans: false,
      errObj: {},
    };
  },
  computed: {
    currentPlan() {
      if (!this.providerPlan.planId) {
        return 'None';
      }
      const {
        name,
        priceInitial,
        chargeFrequency,
      } = this.providerPlan;
      return `${name} $${priceInitial}/${chargeFrequency}`;
    },
    planOptions() {
      return this.allCorpPlans.map((p) => ({
        label: p.name,
        value: p.planId,
      }));
    },
  },
  mounted() {
    this.handleMount();
  },
  methods: {
    async updateCustomerProviderPlan() {
      const errObj = {};
      if (!this.selectedProviderPlan) {
        errObj.pleaseSelect = 'Please select a plan';
      }
      this.errObj = errObj;
      if (Object.keys(errObj).length === 0) {
        this.updating = true;
        await this.$store.dispatch('updateCustomerProviderPlan', {
          customerId: this.customer.id,
          newProviderPlanId: this.selectedProviderPlan,
        });
        this.$store.dispatch('showSuccessToast', {
          message: 'Success! Member\'s plan has been updated',
        });
        this.updating = false;
        this.toggleActionModal(false);
      }
    },
    selectProviderPlan(value) {
      this.selectedProviderPlan = value;
    },
    async handleMount() {
      this.loadingPlans = true;
      await this.$store.dispatch('getPartnerProviderPlans', { corpId: this.customer.corporationId });
      if (this.providerPlan && this.providerPlan.status === 'Active') {
        this.selectedProviderPlan = this.providerPlan.planId;
      }
      this.loadingPlans = false;
    },
  },
};
</script>
